import { Checkbox, FormControlLabel, CheckboxProps } from '@mui/material';

type DpCheckboxFormProps = CheckboxProps & {
	children?: React.ReactNode;
	label?: string;
};

export const DpCheckboxSatisForm: React.FC<DpCheckboxFormProps> = ({
	label,
	children,
	...props
}) => (
	<FormControlLabel
		control={
			<Checkbox
				sx={{
					paddingBottom: '3px',
				}}
				{...props}
			/>
		}
		label={label || children}
	/>
);
